export default function (instance) {
  return {
    getPostsData: (payload) => instance.post("api/post/all", payload),
  };
}
